import { createStore } from "zustand/vanilla";
import { persist, createJSONStorage } from "zustand/middleware";
import { createSidebarSlice } from "./slices/sidebar";
import { createChatSessionsSlice } from "./slices/chat-sessions";
import { createSessionMessagesSlice } from "./slices/session-messages";
import { createDatabaseSlice } from "./slices/database";
import { createCurrentSessionSlice } from "./slices/current-session";
import { createAnalysisDocumentSlice } from "./slices/analysis-document";
import { createConnectionAttachmentsSlice } from "./slices/connection-attachments";

export const createGlobalStore = () => {
  return createStore(
    persist<any>(
      (set, get, storeApi) => ({
        ...createSidebarSlice(set, get, storeApi),
        ...createChatSessionsSlice(set, get, storeApi),
        ...createSessionMessagesSlice(set, get, storeApi),
        ...createDatabaseSlice(set, get, storeApi),
        ...createCurrentSessionSlice(set, get, storeApi),
        ...createAnalysisDocumentSlice(set, get, storeApi),
        ...createConnectionAttachmentsSlice(set, get, storeApi),
        resetAll: () => {
          createSidebarSlice(set, get, storeApi).reset();
          createChatSessionsSlice(set, get, storeApi).reset();
          createSessionMessagesSlice(set, get, storeApi).reset();
          createDatabaseSlice(set, get, storeApi).reset();
          createCurrentSessionSlice(set, get, storeApi).reset();
          createAnalysisDocumentSlice(set, get, storeApi).reset();
          createConnectionAttachmentsSlice(
            set,
            get,
            storeApi
          ).resetAttachments();
        },
      }),
      {
        name: "global-store",
        storage: createJSONStorage(() => localStorage),
        skipHydration: true,
      }
    )
  );
};
